import { ISummaryQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { formatFixed } from '../../shared/helpers/formatNumber'
import { formatReportRange } from '../../shared/helpers/reportRows'
import { ReportDateRange } from '../../shared/types/row'
import { Q2SummaryValues } from '../types/row'

const EMPTY_SUMMARY: Q2SummaryValues = {
  dateRange: '',
  amountPack: '0',
  middlePrice: '0.00',
  amountPallets: '0',
  weight: '0.00',
}

export const formatQ2Summary = (
  summary: ISummaryQ4 | null,
  range: ReportDateRange | null,
): Q2SummaryValues => ({
  dateRange: formatReportRange(range),
  amountPack: summary ? summary.AmountPack.toLocaleString() : EMPTY_SUMMARY.amountPack,
  middlePrice: summary ? summary.MiddlePrice.toFixed(2) : EMPTY_SUMMARY.middlePrice,
  amountPallets: summary ? summary.AmountPallets.toLocaleString() : EMPTY_SUMMARY.amountPallets,
  weight: summary ? formatFixed(summary.Weight) : EMPTY_SUMMARY.weight,
})
